module.exports = __webpack_public_path__ + "static/img/icon-3.8d38244.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-3.png
// module id = 9eTL
// module chunks = 1 3 4 5 6 7